import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from './auth.service';

@Component({
  selector: 'app-auth',
  templateUrl: './auth.component.html',
  styleUrl: './auth.component.css',
})
export class AuthComponent implements OnInit {
  error: string;

  private route = inject(ActivatedRoute);
  private router= inject(Router)
  private authService= inject(AuthService);

  ngOnInit(): void {
    this.route.queryParams.subscribe(
      (queryParams) => {
        if (queryParams['error']) {
          this.error = window.atob(queryParams['error']);
          alert('Error: ' + this.error);
          this.router.navigate(['/login']);
        } else {
          // const cookieExist = this.authService.getCookie();
          // if (!cookieExist) {
          //   alert('Error: No cookie set or no value saved in Auth cookie');
          //   this.authService.deleteCookie();
          //   this.router.navigate(['/login']);
          // } else {
          //   this.authService.getLoggedInUser();
            this.router.navigate(['/home']);
          // }
        }
      }
    );
  }
}
